import ServersPage from '@/modules/admin/servers/servers-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/admin/servers')({
  component: ServersPage,
});
